import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";

/**
 * Retrieves a Courier authentication token for the current user.
 * 
 * @returns {Promise<string>} Promise resolving to the Courier JWT token
 * 
 * @example
 * const token = await getCourierToken();
 * courier.shared.signIn({ userId: user.uid, jwt: token });
 */
export const getCourierToken = async (): Promise<string> => {
  const callable = httpsCallable<void, string>(functions, "getCourierTokenCallable");
  const result = await callable();
  return result.data;
};
